<template>
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link"  @click="showMenuDefault"><i class="iocn icon-arrow-left"></i> {{$lang.Menu.Common.Back}} Menu Principal</a>
    </li>
    <li class="nav-title">
      {{$lang.Menu.Section.Reports}}
    </li>
    <li class="nav-item">
      <router-link :to="{ name: 'Relatorios' }" class="nav-link"><i class="fa fa-caret-right"></i> Relatório 1 </router-link>
    </li>
    <li class="nav-item">
      <router-link :to="{ name: 'Relatorios' }" class="nav-link"><i class="fa fa-caret-right"></i> Relatório 2 </router-link>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'ReportSidebar',
  methods: {
    showMenuDefault () {
      this.$emit('ReturnMenuDefault')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/layout/sidebar/ReportSidebar.vue